import React, { forwardRef } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";

const Checkbox = forwardRef(
  (
    {
      label,
      className = "",
      containerClassName = "",
      labelClassName = "",
      error = false,
      disabled = false,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`relative flex items-start ${containerClassName}`}>
        <div className="flex h-6 items-center">
          {/* Hidden actual input */}
          <input
            {...props}
            ref={ref}
            type="checkbox"
            disabled={disabled}
            className={`
              absolute h-6 w-6 opacity-0 z-10
              ${disabled ? "cursor-not-allowed" : "cursor-pointer"}
            `}
          />

          {/* Visible checkbox */}
          <div
            className={`
              relative flex h-5 w-5 items-center justify-center rounded-md border-2
              transition-all duration-150
              ${
                error
                  ? "border-red-500"
                  : "border-zinc-300 hover:border-zinc-400 peer-focus:border-zinc-900"
              }
              ${
                props.checked
                  ? `bg-zinc-900 border-zinc-900 ${
                      !disabled && "hover:bg-zinc-800"
                    }`
                  : "bg-white"
              }
              ${disabled ? "bg-zinc-100 border-zinc-200" : ""}
              ${className}
            `}
          >
            <CheckIcon
              className={`
                h-4 w-4 text-white transition-opacity
                ${props.checked ? "opacity-100" : "opacity-0"}
              `}
              strokeWidth={3}
            />
          </div>
        </div>

        {label && (
          <div className="ml-3 text-sm leading-6">
            <label
              className={`
                font-medium
                ${disabled ? "text-zinc-400" : "text-zinc-900"}
                ${labelClassName}
              `}
            >
              {label}
            </label>
            {error && typeof error === "string" && (
              <p className="mt-1 text-red-600 text-sm">{error}</p>
            )}
          </div>
        )}
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
